<template>
  <div class="settings-inner-box">
    <div class="clearfix">
      <p class="settings-heading">Listening preferences (coming soon)</p>
      <p class="close-icon" @click="close">
        <img src="~@/assets/img/close.svg" alt="close" class="icon" aria-label="close"/>
      </p>
    </div>
    <form v-on:submit.prevent="handleFormSubmit" class="setting-form">
      <p class="field-heading">Voice</p>
      <input type="checkbox" id="female" value="female" v-model="userPreference.gender" disabled>
      <label class="form-label" for="female">Female</label>
      <input type="checkbox" id="male" value="male" v-model="userPreference.gender" disabled>
      <label class="form-label" for="male">Male</label>
      <p class="form-helptext">These selections apply only to vocal renditions</p>

      <p class="field-heading">Type of music</p>
      <input type="checkbox" id="vocal" value="vocal" v-model="userPreference.musictype" disabled>
      <label class="form-label" for="vocal">Vocal</label>
      <input type="checkbox" id="instrumental" value="instrumental"
        v-model="userPreference.musictype" disabled>
      <label class="form-label" for="instrumental">Instrumental</label>
      <div class="btn-wrapper">
        <button type="submit" class="btn">Apply</button>
        <p class="form-helptext">These preferences are saved to your browser and
         will remain until it is reset</p>
      </div>
    </form>
    <p class="error-msg">{{ errorMsg }}</p>
  </div>
</template>

<script>
import Utils from '../mixins/utils';

export default {
  name: 'Settings',
  data() {
    return {
      errorMsg: '',
    };
  },
  mixins: [Utils],
  props: ['userPreference'],
  methods: {
    close() {
      this.$emit('close');
    },
    handleFormSubmit() {
      if (this.userPreference.gender || this.userPreference.musictype) {
        this.$emit('filterSongs');
      } else {
        this.errorMsg = 'Select any one listening preference.';
      }
    },
  },
};
</script>
